@charset "UTF-8";

/* src/app/forms/wizard-configuracao/data-save-configuration/data-save-configuration.component.scss */
.title-panel {
  width: 100%;
  font-size: large;
  font-weight: 500;
  margin-bottom: 6px;
}
.info {
  margin-top: 10px;
  margin-bottom: 10px;
  border-radius: 4px;
  padding: 15px;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.24), 0 0 2px rgba(0, 0, 0, 0.12);
  background-color: #FFFFE1;
  font-weight: 300;
  text-align: center;
}
properties-value-view {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.full-width {
  width: 100%;
}
.data-save-body {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
}
.mat-mdc-table {
  width: 100%;
}
.mat-mdc-header-cell,
.mat-mdc-cell {
  flex: 1 1 0px;
}
table {
  width: 100%;
  table-layout: fixed;
}
.cell-content {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 90%;
  margin-top: 4px;
  font-size: 80%;
}
.mat-mdc-row,
.mat-mdc-header-row {
  display: flex;
  width: 100%;
  flex-wrap: nowrap;
}
.mat-mdc-cell,
.mat-mdc-header-cell {
  flex-basis: 0;
  flex-grow: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.mat-mdc-cell {
  flex-basis: 0;
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 100%;
}
.mat-mdc-header-cell {
  display: flex;
  align-items: center;
  justify-content: center;
}
.grid-input {
  height: 100%;
  width: 100%;
}
.more-options {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 90%;
  padding-right: 10px;
  padding-left: 10px;
}
.more-options-horizontal {
  display: flex;
  flex-direction: row;
  gap: 4px;
}
.suspended-menu {
  position: absolute;
  display: flex;
  flex-direction: column;
  max-height: 300px;
  border: 1px solid rgba(0, 0, 0, 0.1215686275);
  overflow: auto;
  border-radius: 4px;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.24), 0 0 2px rgba(0, 0, 0, 0.12);
  right: 0;
  top: 50px;
  z-index: 100;
}
/*# sourceMappingURL=data-save-configuration.component.css.map */
